// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2jozd","forms":"Login_forms__LF7Pt"};